import { ReferenceInput } from 'react-admin';
const filterToQuery = (q: string, filterKey: string) => {
  if (q === '' || filterKey === undefined) {
    return {};
  }
  const filter: any = {};
  filter[`${filterKey}`] = q;
  return filter;
};
const ReferenceInputA = (props: any) => (
  <ReferenceInput
    sort={{ field: 'updatedAt', order: 'DESC' }}
    filterToQuery={q => {
      return filterToQuery(q, props.filterKey);
    }}
    perPage={25}
    {...props}
  />
);

export default ReferenceInputA;
